import { render } from "./toast.vue?vue&type=template&id=4ea63169&scoped=true"
const script = {}

import "./toast.vue?vue&type=style&index=0&id=4ea63169&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ea63169"

export default script